import _ from 'lodash'

// Select color from theme, theme.colors, or use literal value
export const getColor = (color, fallback) => {
    color = _.isString(color) ? _.toPath(color) : color
    fallback = _.isString(fallback) ? _.toPath(fallback) : fallback

    return props => {
        if (fallback != null && !fallback) fallback = null
        let value = _.isFunction(color)
            ? color(props)
            : _.get(props.theme, color) || _.get(props.theme.colors, color) || _.get(props, color)

        if (value == null && fallback == null) {
            return color
        }

        if (value == null) {
            value = _.isFunction(fallback) ? fallback(props) : getColor(fallback, null)(props)
        }

        if (value[0] === '#' || _.startsWith(value, 'rgb') || _.startsWith(value, 'hsl')) {
            return value
        }

        value = getColor(value, null)(props) || (fallback ? getColor(fallback, null)(props) : null)

        return value
    }
}

export default getColor



// WEBPACK FOOTER //
// ./src/theme/getColor.js